/**
 * Do not edit directly, this file was auto-generated.
 */

const colors = {
    "background-page": "var(--jkl-color-background-page)",
    "background-page-variant": "var(--jkl-color-background-page-variant)",
    "background-container": "var(--jkl-color-background-container)",
    "background-container-low": "var(--jkl-color-background-container-low)",
    "background-container-high": "var(--jkl-color-background-container-high)",
    "background-container-inverted": "var(--jkl-color-background-container-inverted)",
    "background-container-subdued": "var(--jkl-color-background-container-subdued)",
    "background-input-base": "var(--jkl-color-background-input-base)",
    "background-input-focus": "var(--jkl-color-background-input-focus)",
    "background-action": "var(--jkl-color-background-action)",
    "background-interactive": "var(--jkl-color-background-interactive)",
    "background-interactive-hover": "var(--jkl-color-background-interactive-hover)",
    "background-interactive-selected": "var(--jkl-color-background-interactive-selected)",
    "background-alert-neutral": "var(--jkl-color-background-alert-neutral)",
    "background-alert-info": "var(--jkl-color-background-alert-info)",
    "background-alert-success": "var(--jkl-color-background-alert-success)",
    "background-alert-warning": "var(--jkl-color-background-alert-warning)",
    "background-alert-error": "var(--jkl-color-background-alert-error)",
    "text-default": "var(--jkl-color-text-default)",
    "text-subdued": "var(--jkl-color-text-subdued)",
    "text-inverted": "var(--jkl-color-text-inverted)",
    "text-on-action": "var(--jkl-color-text-on-action)",
    "text-interactive": "var(--jkl-color-text-interactive)",
    "text-interactive-hover": "var(--jkl-color-text-interactive-hover)",
    "text-on-alert": "var(--jkl-color-text-on-alert)",
    "text-on-alert-subdued": "var(--jkl-color-text-on-alert-subdued)",
    "border-action": "var(--jkl-color-border-action)",
    "border-input": "var(--jkl-color-border-input)",
    "border-input-focus": "var(--jkl-color-border-input-focus)",
    "border-separator": "var(--jkl-color-border-separator)",
    "border-separator-strong": "var(--jkl-color-border-separator-strong)",
    "border-separator-hover": "var(--jkl-color-border-separator-hover)",
    "border-subdued": "var(--jkl-color-border-subdued)",
};

export default colors;
